import { actionTypes } from './action';

export interface TourState {
    isStared: boolean;
    isDone: boolean;
    pages: {
        home: boolean;
        referral: boolean;
        marketplace: boolean;
        profile: boolean;
        adventure: boolean;
        treasure: boolean;
        preFight: boolean;
        myLands: boolean;
    };
    completedTours: Record<string, boolean>;
    activeTour: string | null;
    tourSteps: Record<string, number>;
    tourRunStates: Record<string, boolean>;
}

export const tourDefaultState: TourState = {
    isStared: false,
    isDone: false,
    pages: {
        home: false,
        referral: false,
        marketplace: false,
        profile: false,
        adventure: false,
        treasure: false,
        preFight: false,
        myLands: false,
    },
    completedTours: {},
    activeTour: null,
    tourSteps: {},
    tourRunStates: {}
};

export const TourReducer = (state = tourDefaultState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_TOUR:
            return action.payload;
        case actionTypes.SET_TOUR_COMPLETED:
            return {
                ...state,
                completedTours: {
                    ...state.completedTours,
                    [action.payload]: true
                },
                tourSteps: {
                    ...state.tourSteps,
                    [action.payload]: 0
                },
                tourRunStates: {
                    ...state.tourRunStates,
                    [action.payload]: false
                }
            };
        case actionTypes.SET_ACTIVE_TOUR:
            return {
                ...state,
                activeTour: action.payload
            };
        case actionTypes.RESET_TOUR:
            return {
                ...state,
                completedTours: {
                    ...state.completedTours,
                    [action.payload]: false
                },
                tourSteps: {
                    ...state.tourSteps,
                    [action.payload]: 0
                }
            };
        case actionTypes.UPDATE_TOUR_STEP:
            return {
                ...state,
                tourSteps: {
                    ...state.tourSteps,
                    [action.payload.tourId]: action.payload.step
                }
            };
        case actionTypes.SET_TOUR_RUN_STATE:
            return {
                ...state,
                tourRunStates: {
                    ...state.tourRunStates,
                    [action.payload.tourId]: action.payload.running
                }
            };
        case actionTypes.CLEAR_TOUR_RUN_STATE:
            return {
                ...state,
                tourRunStates: {},
                activeTour: null
            };
        case actionTypes.CLEAR_TOUR:
            return tourDefaultState;
        default:
            return state;
    }
};
